import { createContext } from 'react';
import { Theme } from '@fluentui/react-components';

console.log('[local] Create context..');

export const TeamsFxContext = createContext<{
	theme?: Theme;
	themeString: string;
}>({
	theme: undefined,
	themeString: '',
});
